/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import GRID_STEP_1 from "./GRID_STEP_1";
import GRID_STEP_2 from "./GRID_STEP_2";
import GRID_STEP_3 from "./GRID_STEP_3";

/*REDUX*/
import {
  set_value_toolbox,
  status_toolbox,
} from "../../App/actions/toolboxActions";
import { set_value_layer } from "../../App/actions/layerActions";
import { status_action } from "../../App/actions/mapActions";

/*PICTURE*/
import ICON_ARROW_LEFT_LINE from "../../Assets/jsx/ICON_ARROW_LEFT_LINE";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class TOOLBOX_GRID extends Component {
  componentDidMount() {
    const { geo_layer_list } = this.props.layer;
    const layer_list_point_raw = geo_layer_list
      .filter((item) => item?.geo_layer?.type === "Point")
      .map((item) => {
        return { _id: item?.geo_layer?._id, name: item?.geo_layer?.name };
      });
    const layer_list_point_filtered = geo_layer_list
      .filter((item) => item?.geo_layer?.type === "Point")
      .map((item) => {
        return { _id: item?.geo_layer?._id, name: item?.geo_layer?.name };
      });
    const layer_list_polygon_raw = geo_layer_list
      .filter((item) => item?.geo_layer?.type === "Polygon")
      .map((item) => {
        return { _id: item?.geo_layer?._id, name: item?.geo_layer?.name };
      });
    const layer_list_polygon_filtered = geo_layer_list
      .filter((item) => item?.geo_layer?.type === "Polygon")
      .map((item) => {
        return { _id: item?.geo_layer?._id, name: item?.geo_layer?.name };
      });
    this.props.set_value_toolbox({
      key: "layer_list_point_raw",
      value: layer_list_point_raw,
    });
    this.props.set_value_toolbox({
      key: "layer_list_point_filtered",
      value: layer_list_point_filtered,
    });
    this.props.set_value_toolbox({
      key: "layer_list_polygon_raw",
      value: layer_list_polygon_raw,
    });
    this.props.set_value_toolbox({
      key: "layer_list_polygon_filtered",
      value: layer_list_polygon_filtered,
    });
  }

  on_back = () => {
    this.props.set_value_toolbox({
      key: "mode_toolbox",
      value: "features_distance",
    });
    this.props.set_value_layer({
      key: "draw_state_platform",
      value: "",
    });
    this.props.set_value_toolbox({
      key: "mode_draw",
      value: "simple_select",
    });
    this.props.status_action();
    const { map_object } = this.props.layer;
    if (map_object) {
      map_object.getCanvas().style.cursor = "";

      const draw_object = this.props.layer.draw_object;

      if (draw_object) {
        draw_object.changeMode("simple_select");
      }
    }
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    //global props

    //content

    return (
      <main
        className="parent_section_full"
        style={{ height: "calc( 100vh - 110px )" }}
      >
        <section className="section_1 margin_bottom">
          <button
            className="button_pill background_grey_light margin_bottom"
            onClick={this.on_back}
          >
            <span className="badge_circle background_black margin_right">
              <ICON_ARROW_LEFT_LINE fill="#fff" />
            </span>
            <span className="margin_right">{dict?.["Back"]?.[language]}</span>
          </button>
          <h1 className="text_header">TOOLBOX GRID</h1>
        </section>
        <section
          className="section_2"
          style={{ paddingRight: "10px", paddingBottom: "100px" }}
        >
          <GRID_STEP_1 />
          <GRID_STEP_2 />
          <GRID_STEP_3 />
        </section>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  toolbox: state.toolbox,
  map: state.map,
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, {
  set_value_toolbox,
  set_value_layer,
  status_action,
  status_toolbox,
})(TOOLBOX_GRID);
